var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "220.000000pt",
    height: "229.000000pt",
    viewBox: "0 0 220.000000 229.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,229.000000) scale(0.100000,-0.100000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190 1991 l0 -109 221 -253 c122 -140 240 -274 263 -299 23 -25 67 -75 99 -111 l57 -66 0 -329 0 -329 171 -112 171 -113 99 0 99 0 0 440 0 441 320 365 320 365 0 109 0 110 -910 0 -910 0 0 -109z m1518 -178 c-51 -59 -161 -184 -244 -278 -82 -93 -178 -203 -212 -244 l-62 -74 -2 -368 -3 -369 -87 58 -88 57 0 310 0 310 -33 41 c-28 35 -342 396 -515 592 l-64 72 702 0 701 0 -93 -107z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.69a0d8a0ad0c2da5d24a0275912f6bbe.svg";
export { ForwardRef as ReactComponent };